/* Component Dependencies */
var videoTemplate = require('templates/video.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'video',
  template: {
    'video': videoTemplate
  },
  bindEvents: function() {
    var _self= this;
    if(_self.$el.find('video')) {
      _self.$el.find('video').play();
    }
  }
});
